<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/warranties"
      title="Lista gwarancji"
      :numeral_text="['gwarancja', 'gwarancje', 'gwarancji']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
